import { useTranslation } from 'react-i18next';

const languages = [
  { code: 'th', label: 'ไทย' },
  { code: 'en', label: 'EN' },
] as const;

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const currentLang = i18n.language;

  return (
    <div className="flex items-center gap-1" role="group" aria-label="Language selector">
      {languages.map(({ code, label }) => (
        <button
          key={code}
          type="button"
          onClick={() => i18n.changeLanguage(code)}
          aria-pressed={currentLang === code}
          className={`min-h-[44px] min-w-[44px] rounded-md px-3 py-2 text-sm font-medium transition-colors ${
            currentLang === code
              ? 'bg-teal-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          {label}
        </button>
      ))}
    </div>
  );
}
